import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../services/apirest";

function HabilitarDeshabilitarChofer(props) {
  const [choferData, setChoferData] = useState(null);
  const [disBtn, setDisBtn] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (props.chofer) {
      setChoferData(props.chofer);
    }
  }, [props.chofer]);

  const handleClose = () => {
    props.setOpen(false);
    // Limpiar datos después de cerrar
    setTimeout(() => {
      setChoferData(null);
    }, 300);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Si no hay datos del chofer o el diálogo está cerrado, no renderizar
  if (!props.open || !choferData) {
    return null;
  }

  // Determinar si es habilitar o deshabilitar
  const isHabilitar = props.accion === "habilitar";
  const titulo = isHabilitar ? "Habilitar" : "Deshabilitar";
  const colorBoton =  "success";
  const mensaje = isHabilitar
    ? `¿Seguro que quiere HABILITAR las rendiciones extendidas para ${choferData.nombre_apellido || ''}?`
    : `¿Seguro que quiere DESHABILITAR las rendiciones extendidas para ${choferData.nombre_apellido || ''}?`;

  async function handleAccion(e) {
    e.preventDefault();
    setDisBtn(true);
    
    const nuevoEstado = isHabilitar ? 1 : 0;
    
    try {
      const response = await fetch(`${UrlApi}/envasado_rendiciones_extendidas/${choferData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ activo: nuevoEstado }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      
      setSnackbar({
        open: true,
        message: `Chofer ${isHabilitar ? 'habilitado' : 'deshabilitado'} correctamente`,
        severity: "success",
      });
      
      // Cerrar diálogo y actualizar lista después de 1.5 segundos
      setTimeout(() => {
        props.actualizar();
        props.setOpen(false);
        setChoferData(null);
        setDisBtn(false);
      }, 1500);
      
    } catch (error) {
      console.error('Error:', error);
      setSnackbar({
        open: true,
        message: `Error al ${isHabilitar ? 'habilitar' : 'deshabilitar'} el chofer: ${error.message}`,
        severity: "error",
      });
      setDisBtn(false);
    }
  }

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <form onSubmit={handleAccion}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                {titulo} de chofer: {choferData.nombre_apellido || ''}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              {mensaje}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Volver
              </Button>
              <Button 
                color={colorBoton} 
                type="submit" 
                variant="contained"
                disabled={disBtn}
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default HabilitarDeshabilitarChofer;